import { render, staticRenderFns } from "./BlockSubGroup1Helplist.vue?vue&type=template&id=2354abf4&"
import script from "./BlockSubGroup1Helplist.vue?vue&type=script&lang=js&"
export * from "./BlockSubGroup1Helplist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports